import { Injectable } from "@angular/core";
import { ReportTask } from "./report-task.model";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { GetReportTasksModel } from "src/app/_models/report-task-request.model";
import { Utils } from "src/app/_helpers/utils";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class ReportTaskService {
  constructor(private http: HttpClient) {}

  reportTask: ReportTask;
  reportTasks: ReportTask[];
  tableName = "report_task";

  createReportTask() {
    return this.http.post(url + "report-task", this.reportTask);
  }

/**
 * @param requestModel Paramtry do funkcji w postaci obiektu
 */
  getReportTasks(requestModel: GetReportTasksModel) {
    return this.http.get<ReportTask[]>(url + "report-task", { params: Utils.httpParams(requestModel)});
  }

  getReportTasksByReportId(reportId: string) {
    return this.http.get<ReportTask[]>(url + "report-task?report=" + reportId);
  }

  getReportTask(reportTaskId: string) {
    return this.http.get(url + "report-task/" + reportTaskId);
  }

  updateReportTask() {
    return this.http.put(
      url + "report-task/" + this.reportTask.id,
      this.reportTask
    );
  }
}
